import React from "react";
import { RowComponent } from "../Row";
import { StageElement, type ViewerDeviceRuntime } from "../../../../types";
import { resolveImageUrlForDevice } from "../../../../util/resolveOfflinePackageImageUrl";
import { StyledSection, SectionBackgroundWrapper, PaddedSectionContent } from "./styles";

interface SectionProps {
  section: {
    rowsAreFullWidth?: boolean;
    backgroundImageUrl?: string;
    cssClass?: string;
    ref?: string;
    backgroundImageAltText?: string;
    backgroundColor?: string;
    backgroundParallax?: {
      type?: string;
      speed?: number;
    };
    rows?: Array<{
      ref?: string;
      columns?: Array<{
        ref?: string;
        stageElements?: StageElement[];
      }>;
    }>;
  };
  renderStageElement: (element: StageElement, elementIndex: string) => JSX.Element | null;
  defaultStyles?: string;
  viewerDevice?: ViewerDeviceRuntime;
}

export const SectionComponent: React.FC<SectionProps> = ({
  section,
  renderStageElement,
  defaultStyles,
  viewerDevice,
}) => {
  if (!section.rows) {
    return null;
  }

  const backgroundImageUrl = section.backgroundImageUrl
    ? resolveImageUrlForDevice(section.backgroundImageUrl, viewerDevice)
    : undefined;

  return (
    <StyledSection
      className={`spf-rce-section ${section.cssClass || ""}`}
      fullWidth={section.rowsAreFullWidth}
      backgroundColor={section.backgroundColor}
    >
      <SectionBackgroundWrapper
        className="spf-rce-section-background-wrapper"
        imageURL={backgroundImageUrl}
        backgroundColor={section.backgroundColor}
        speed={section.backgroundParallax?.speed}
        parallaxDirection={section.backgroundParallax?.type || "vertical"}
        defaultStyles={defaultStyles}
        fullWidth={section.rowsAreFullWidth}
        readOnly={true}
      >
        <PaddedSectionContent
          className="spf-rce-section-content"
          title={section.backgroundImageAltText}
          fullWidth={section.rowsAreFullWidth}
          readOnly={true}
        >
          {section.rows.map((row, rowPosition) => (
            <RowComponent
              key={`row-${rowPosition}`}
              row={row}
              renderStageElement={renderStageElement}
            />
          ))}
        </PaddedSectionContent>
      </SectionBackgroundWrapper>
    </StyledSection>
  );
};
